import { Box, Menu, MenuButton, MenuItem, MenuList } from '@tonic-one/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import DashboardCard from '../../Layout/DashboardCard';
import { useGlobalSettingStore } from '../../../../models/useGlobalSettingModel';
import { ServiceTimeRangeCount } from '@Dashboard/Charts/ServiceTimeRangeCount';

function VirtualAnalyzerProcessedThreats(props: { data: any; day: string }) {
  const { t } = useTranslation();

  const [chartType, setChartType] = useState('all'); // all | FILE | URL

  const { selectedOrgGlobalSetting } = useGlobalSettingStore();

  useEffect(() => {
    if (!selectedOrgGlobalSetting.urlSandboxFeatureShow) {
      setChartType('FILE');
    }
  }, [selectedOrgGlobalSetting]);

  return (
    <DashboardCard
      row={2}
      height="628px"
      title={t('dashboard.chart.title.virtualAnalyzerProcessedThreats')}
    >
      {selectedOrgGlobalSetting.urlSandboxFeatureShow && (
        <Box mb="5x">
          <Menu>
            <MenuButton variant="secondary" width="40x">
              {t(
                `dashboard.processedThreats.menuList.${formatEnum(chartType)}`
              )}
            </MenuButton>
            <MenuList width="40x" overflow="auto">
              {['all', 'FILE', 'URL'].map((type: string) => {
                return (
                  <MenuItem
                    key={type}
                    onClick={() => {
                      setChartType(type);
                    }}
                    lineHeight="20px"
                  >
                    {t(
                      `dashboard.processedThreats.menuList.${formatEnum(type)}`
                    )}
                  </MenuItem>
                );
              })}
            </MenuList>
          </Menu>
        </Box>
      )}
      <ServiceTimeRangeCount
        data={
          props.data?.virtual_analyzerProcessedUnknownThreats?.[chartType]?.[
            props.day
          ]
        }
        interval={props.day}
        height="500px"
      />
    </DashboardCard>
  );
}

function formatEnum(type: string) {
  switch (type) {
    case 'all':
      return 'filesAndUrls';
    case 'FILE':
      return 'files';
    case 'URL':
      return 'urls';
    default:
      throw new Error('Invalid type');
  }
}

export default React.memo(VirtualAnalyzerProcessedThreats);
